module.exports = __webpack_public_path__ + "static/ticket-number-a8c3789b6edad320805e561ac7724f43.svg";